class DisabledPeople {
  constructor(
    firstName,
    lastName,
    mainPhoneNumber,
    otherPhoneNumbers,
    address,
    nationalCode,
    birthDate,
    cityId,
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.mainPhoneNumber = mainPhoneNumber;
    this.otherPhoneNumbers = otherPhoneNumbers;
    this.address = address;
    this.nationalCode = nationalCode;
    this.birthDate = birthDate;
    this.cityId = cityId;
  }
}
import Vue from 'vue';
export default {
  inject: ['load'],
  data() {
    return {
      allDisabledPeoples: [],
      allDisabledPeoplesForOther: [],
      disabledPeople: new DisabledPeople('', '', '', '', '', '', '', null),
      disabledPeoplePaginationList: [],
    };
  },
  methods: {
    getListOfDisabledPeoplesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllDisabledPeoples').then(() => {
        if (this.$store.state.disabledPeopleModule.successFlag) {
          this.allDisabledPeoplesForOther =
            this.$store.state.disabledPeopleModule.allDisabledPeoples;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.disabledPeopleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfDisabledPeoplesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.disabledPeopleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfDisabledPeoplesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllDisabledPeoples: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllDisabledPeoples').then(() => {
        if (this.$store.state.disabledPeopleModule.successFlag) {
          this.allDisabledPeoples = this.$store.state.disabledPeopleModule.allDisabledPeoples;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.disabledPeopleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllDisabledPeoples();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.disabledPeopleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllDisabledPeoples();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfDisabledPeoplesWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getDisabledPeoplesWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          fullName: this.searchFullName,
          nationalCode: this.searchNationalCode,
          mainPhoneNumber: this.searchMainPhoneNumber,
          cityId: this.searchCityId,
        })
        .then(() => {
          if (this.$store.state.disabledPeopleModule.successFlag) {
            this.disabledPeoplePaginationList = [];
            let temp = this.$store.state.disabledPeopleModule.disabledPeoples;
            for (let i = 0; i < temp.length; i++) {
              let fullName = '';
              fullName += temp[i].firstName + ' ' + temp[i].lastName;
              let birthDate = '-';
              if (temp[i].birthDate) {
                birthDate = Vue.moment(temp[i].birthDate).format('jYYYY-jMM-jDD');
              }
              this.disabledPeoplePaginationList.push({
                fullName: fullName,
                phoneNumber: temp[i].mainPhoneNumber ? temp[i].mainPhoneNumber : '-',
                otherPhoneNumber: temp[i].otherPhoneNumbers ? temp[i].otherPhoneNumbers : '-',
                address: temp[i].address ? temp[i].address : '-',
                nationalCode: temp[i].nationalCode ? temp[i].nationalCode : '-',
                birthDate: birthDate,
                city: temp[i].city ? temp[i].city.title : '-',
                status: temp[i].isActive,
                id: temp[i].id,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.disabledPeopleModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.disabledPeopleModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.disabledPeopleModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.disabledPeopleModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfDisabledPeoplesWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.disabledPeopleModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfDisabledPeoplesWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addDisabledPeopleFunction: function () {
      if (!this.disabledPeople.firstName) {
        this.snackText = 'نام فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.firstName.replace(/\s/g, '').length) {
        this.snackText = 'نام فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.lastName) {
        this.snackText = 'نام خانوادگی فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.lastName.replace(/\s/g, '').length) {
        this.snackText = 'نام خانوادگی فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.nationalCode) {
        this.snackText = 'کد ملی فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.disabledPeople.nationalCode.length < 10) {
        this.snackText = 'کد ملی وارد شده معتبر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.mainPhoneNumber) {
        this.snackText = 'شماره اصلی فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.disabledPeople.mainPhoneNumber.length < 11) {
        this.snackText = 'شماره اصلی وارد شده معتبر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.address) {
        this.snackText = 'آدرس فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.address.replace(/\s/g, '').length) {
        this.snackText = 'آدرس فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.cityId) {
        this.snackText = 'شهر فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.birthDate) {
        this.disabledPeople.birthDate = null;
      }
      if (this.disabledPeoplephoneNumbers.length > 0) {
        for (let i = 0; i < this.disabledPeoplephoneNumbers.length; i++) {
          this.disabledPeople.otherPhoneNumbers += this.disabledPeoplephoneNumbers[i].text;
          this.disabledPeople.otherPhoneNumbers += ',';
        }
      }
      if (this.disabledPeople.otherPhoneNumbers) {
        this.disabledPeople.otherPhoneNumbers = this.removeLastCharechter(
          this.disabledPeople.otherPhoneNumbers,
        );
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addDisabledPeople', this.disabledPeople).then(() => {
        if (this.$store.state.disabledPeopleModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' فرد ناتوان با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.disabledPeople = new DisabledPeople('', '', '', '', '', null, null, null);
          this.disabledPeoplephoneNumbers = [];
          this.tempDisabledPeopleBrithDate = '';
          this.getListOfDisabledPeoplesWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.disabledPeopleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addDisabledPeopleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.disabledPeopleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addDisabledPeopleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getDisabledPeopleFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDisabledPeople', id).then(() => {
        if (this.$store.state.disabledPeopleModule.successFlag) {
          let temp = this.$store.state.disabledPeopleModule.disabledPeople;
          this.disabledPeople.id = temp.id;
          this.disabledPeople.firstName = temp.firstName;
          this.disabledPeople.lastName = temp.lastName;
          this.disabledPeople.nationalCode = temp.nationalCode;
          this.disabledPeople.mainPhoneNumber = temp.mainPhoneNumber;
          this.disabledPeople.address = temp.address;
          this.disabledPeople.isActive = temp.isActive;
          this.disabledPeople.cityId = temp.city.id;
          this.disabledPeople.birthDate = temp.birthDate;
          this.tempDisabledPeopleBrithDate = temp.birthDate
            ? Vue.moment(temp.birthDate).format('jYYYY-jMM-jDD')
            : '';
          if (temp.otherPhoneNumbers.length > 0) {
            let phoneNumbers = temp.otherPhoneNumbers.split(',');
            for (let i = 0; i < phoneNumbers.length; i++) {
              this.disabledPeoplephoneNumbers.push({
                text: phoneNumbers[i],
                id: i + 1,
              });
            }
          }
          if (temp.isActive == false) {
            this.isActive = false;
          } else {
            this.isActive = true;
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.disabledPeopleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getDisabledPeopleFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.disabledPeopleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getDisabledPeopleFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editDisabledPeopleFunction: function () {
      if (!this.disabledPeople.firstName) {
        this.snackText = 'نام فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.firstName.replace(/\s/g, '').length) {
        this.snackText = 'نام فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.lastName) {
        this.snackText = 'نام خانوادگی فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.lastName.replace(/\s/g, '').length) {
        this.snackText = 'نام خانوادگی فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.nationalCode) {
        this.snackText = 'کد ملی فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.disabledPeople.nationalCode.length < 10) {
        this.snackText = 'کد ملی وارد شده معتبر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.mainPhoneNumber) {
        this.snackText = 'شماره اصلی فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.disabledPeople.mainPhoneNumber.length < 11) {
        this.snackText = 'شماره اصلی وارد شده معتبر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.address) {
        this.snackText = 'آدرس فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.address.replace(/\s/g, '').length) {
        this.snackText = 'آدرس فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.cityId) {
        this.snackText = 'شهر فرد ناتوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.disabledPeople.birthDate) {
        this.disabledPeople.birthDate = null;
      }
      if (this.disabledPeoplephoneNumbers.length > 0) {
        for (let i = 0; i < this.disabledPeoplephoneNumbers.length; i++) {
          this.disabledPeople.otherPhoneNumbers += this.disabledPeoplephoneNumbers[i].text;
          this.disabledPeople.otherPhoneNumbers += ',';
        }
      }
      if (this.disabledPeople.otherPhoneNumbers) {
        this.disabledPeople.otherPhoneNumbers = this.removeLastCharechter(
          this.disabledPeople.otherPhoneNumbers,
        );
      }
      this.disabledPeople.isActive = this.isActive;
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editDisabledPeople', this.disabledPeople).then(() => {
        if (this.$store.state.disabledPeopleModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' فرد ناتوان با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.disabledPeople = new DisabledPeople('', '', '', '', '', '', '', null);
          this.disabledPeoplephoneNumbers = [];
          this.tempDisabledPeopleBrithDate = '';
          this.getListOfDisabledPeoplesWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.disabledPeopleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editDisabledPeopleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.disabledPeopleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editDisabledPeopleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getDisabledPeopleDetailFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDisabledPeopleDetail', id).then(() => {
        if (this.$store.state.disabledPeopleModule.successFlag) {
          this.disabledPeopleDetail = this.$store.state.disabledPeopleModule.disabledPeopleDetail;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.disabledPeopleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getDisabledPeopleDetailFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.disabledPeopleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getDisabledPeopleDetailFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteDisabledPeopleFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteDisabledPeople', this.disabledPeopleId).then(() => {
        if (this.$store.state.disabledPeopleModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfDisabledPeoplesWithPagination();
          this.snackText = ' فرد ناتوان با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.disabledPeopleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteDisabledPeopleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.disabledPeopleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteDisabledPeopleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.disabledPeopleModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
